import { getAttrs } from '@common/html/util/dom';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { isEmpty, omitBy } from 'lodash';
import { AttributeSpec, MarkSpec, NodeSpec } from 'prosemirror-model';

export const madcapCustomAttrName = 'MadCap:custom';

export class CustomAttributesSchemaPlugin extends SchemaPlugin {
  modifyNodesAndMarks(nodes: Dictionary<NodeSpec>, marks: Dictionary<MarkSpec>) {
    Object.entries(nodes).forEach(([name, node]) => {
      this.assignCustomAttributes(name, node);
    });

    Object.entries(marks).forEach(([name, mark]) => {
      this.assignCustomAttributes(name, mark);
    });
  }

  private assignCustomAttributes(name: string, spec: MarkSpec | NodeSpec) {
    if (name !== 'text') {
      // Add the custom attribute
      spec.attrs = Object.assign<Dictionary<AttributeSpec>, Dictionary<AttributeSpec>>(spec.attrs ?? {}, {
        [madcapCustomAttrName]: {
          default: undefined,
          toFlareXML: (value: Dictionary<string>): Dictionary<string> => {
            return value;
          },
          toEditorAttr: (value: Dictionary<string>): Dictionary<string> => {
            return value;
          }
        }
      });

      const omitAttrs = Object.keys(spec.attrs).concat('data-pm-slice').map(name => name.toLowerCase());

      // Update the node's parse rules to read in the custom attributes
      if (Array.isArray(spec.parseDOM)) {
        spec.parseDOM.forEach(parser => {
          const originalGetAttrs = parser.getAttrs;

          parser.getAttrs = function (element: Element) {
            const attrs = originalGetAttrs ? originalGetAttrs.apply(this, arguments) : {};

            // Do not modify the attrs if it is a false match (aka not a match)
            if (attrs === false) {
              return false;
            }

            // Grab all the attributes on the element that weren't defined by the schema
            const customAttrs = omitBy(getAttrs(element), (value, key) => {
              return omitAttrs.includes(key.toLowerCase());
            });

            if (!isEmpty(customAttrs)) {
              attrs[madcapCustomAttrName] = customAttrs;
            }
            return attrs;
          };
        });
      }
    }
  }
}
